/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlReportURLResponse
 */
export interface ControlReportURLResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlReportURLResponse
     */
    report_url?: string;
}

/**
 * Check if a given object implements the ControlReportURLResponse interface.
 */
export function instanceOfControlReportURLResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlReportURLResponseFromJSON(json: any): ControlReportURLResponse {
    return ControlReportURLResponseFromJSONTyped(json, false);
}

export function ControlReportURLResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlReportURLResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report_url': !exists(json, 'report_url') ? undefined : json['report_url'],
    };
}

export function ControlReportURLResponseToJSON(value?: ControlReportURLResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report_url': value.report_url,
    };
}

